import { render } from "./readModal.vue?vue&type=template&id=d425e550&scoped=true&ts=true"
import script from "./readModal.vue?vue&type=script&lang=ts"
export * from "./readModal.vue?vue&type=script&lang=ts"

import "./readModal.vue?vue&type=style&index=0&id=d425e550&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d425e550"]])

export default __exports__